
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/register",
      function () {
        return require("private-next-pages/user/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/register"])
      });
    }
  